import React from 'react';
import { FilePdfOutlined } from '@ant-design/icons';
import './styles.css';

const documents = [
    {
        name: 'Оферта',
        url: 'https://cms.e-feed.ru/wp-content/uploads/2024/12/Оферта-пф.pdf',
    },
    {
        name: 'Политика обработки персональных данных',
        url: 'https://cms.e-feed.ru/wp-content/uploads/2024/12/Протектфид-ПОЛИТИКА-ПД-1.pdf',
    },
    {
        name: 'Согласие на обработку в интернете',
        url: 'https://cms.e-feed.ru/wp-content/uploads/2024/12/Согласие-на-обработку-в-интернете-ПФ.pdf',
    },
    {
        name: 'Пользовательское соглашение',
        url: 'https://cms.e-feed.ru/wp-content/uploads/2024/12/Пользовательское-соглашение-ПФ.pdf',
    },
    {
        name: 'Уведомление о файлах cookie',
        url: 'https://cms.e-feed.ru/wp-content/uploads/2024/04/Уведомление-о-файлах-cookie.pdf',
    },
];

const LegalInfo = () => {
    return (
        <div className="legal-page">
            <div className="legal-container">
                <h1 className="legal-title">Правовая информация</h1>

                <section className="legal-section">
                    <h2>Введение</h2>
                    <p>
                        Обеспечение конфиденциальности и безопасности обработки персональных данных в Компании является одной из приоритетных задач организации.
                    </p>
                    <p>
                        В Компании для этих целей введен в действие комплект организационно-распорядительной документации, обязательный к исполнению всеми сотрудниками, допущенными к обработке персональных данных.
                    </p>
                    <p>
                        Обработка, хранение и обеспечение конфиденциальности и безопасности персональных данных осуществляется в соответствии с действующим законодательством РФ в сфере защиты персональных данных, и в соответствии с локальными актами Компании.
                    </p>
                    <p>
                        Настоящая Политика определяет принципы, порядок и условия обработки персональных данных работников Компании и потребителей услуг Компании, чьи персональные данные обрабатываются организацией, с целью обеспечения защиты прав и свобод человека и гражданина при обработке его персональных данных, в том числе защиты прав на неприкосновенность частной жизни, личную и семейную тайну, а также устанавливает ответственность должностных лиц Компании, имеющих доступ к персональным данным, за невыполнение требований норм, регулирующих обработку и защиту персональных данных.
                    </p>
                    <p>
                        Настоящая Политика в отношении обработки персональных данных в Компании (далее — Политика) разработана в соответствии с Федеральным законом от 27 июля 2006 г. № 152-ФЗ «О персональных данных».
                    </p>
                </section>

                <section className="legal-section">
                    <h2>1. Понятие и состав персональных данных</h2>
                    <p>Перечень персональных данных, подлежащих защите в Компании определятся следующими нормативными актами Российской Федерации:</p>
                    <ul>
                        <li>Федеральный закон от 27 июля 2006 г. № 152-ФЗ «О персональных данных»;</li>
                        <li>Федеральный закон от 30 декабря 2001 года № 197-ФЗ «Трудовой кодекс Российской федерации»;</li>
                        <li>Федеральный закон от 06 декабря 2001 года № 402-ФЗ «О бухгалтерском учёте»;</li>
                        <li>Налоговый кодекс Российской Федерации;</li>
                        <li>Гражданский Кодекс Российской Федерации;</li>
                        <li>Федеральный закон от 01 апреля 1996 N 27-ФЗ «Об индивидуальном (персонифицированном) учете в системе обязательного пенсионного страхования»;</li>
                        <li>Трудовой кодекс РФ и другими нормативно-правовыми актами.</li>
                    </ul>
                    <p>
                        Сведениями, составляющими персональные данные, в Компании является любая информация, относящаяся к прямо или косвенно определенному или определяемому физическому лицу (субъекту персональных данных).
                    </p>
                </section>

                <section className="legal-section">
                    <h2>2. Цели обработки персональных данных</h2>
                    <p>Компания осуществляет обработку персональных данных в следующих целях:</p>
                    <ul>
                        <li>организации кадрового учета компании;</li>
                        <li>обеспечения соблюдения законов и иных нормативно-правовых актов;</li>
                        <li>ведения кадрового делопроизводства;</li>
                        <li>исполнения требований налогового законодательства в связи с исчислением и уплатой налога на доходы физических лиц, а также единого социального налога, пенсионного законодательства при формировании и представлении персонифицированных данных о каждом получателе доходов, учитываемых при начислении страховых взносов на обязательное пенсионное страхование и обеспечение;</li>
                        <li>заполнения первичной статистической документации, в соответствии с Трудовым кодексом РФ, Налоговым кодексом РФ, федеральными законами, в частности: «Об индивидуальном (персонифицированном) учете в системе обязательного пенсионного страхования», «О персональных данных» и других нормативно-правовых актов;</li>
                        <li>исполнения договорных обязательств, в том числе гарантийного обслуживания потребителей услуг Компании;</li>
                        <li>иной деятельности в соответствии с Уставом Компании, действующим законодательством Российской федерации.</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>3. Сроки обработки персональных данных</h2>
                    <p>
                        Сроки обработки персональных данных определяются в соответствие со сроком действия договора (соглашением) с субъектом персональных данных, Приказом Минкультуры РФ от 25.08.2010 № 558 «Об утверждении «Перечня типовых управленческих архивных документов, образующихся в процессе деятельности государственных органов, органов местного самоуправления и организаций, с указанием сроков хранения», сроком исковой давности, а также иными требованиями законодательства РФ.
                    </p>
                    <p>
                        В Компании создаются и хранятся документы, содержащие сведения о субъектах персональных данных. Требования к использованию в Компании данных типовых форм документов установлены Постановлением Правительства РФ от 15.09.2008 № 687 «Об утверждении Положения об особенностях обработки персональных данных, осуществляемой без использования средств автоматизации».
                    </p>
                </section>

                <section className="legal-section">
                    <h2>4. Права и обязанности</h2>
                    <p>Компания как оператор персональных данных в праве:</p>
                    <ul>
                        <li>отстаивать свои интересы в суде;</li>
                        <li>предоставлять персональные данные субъектов третьим лицам, если это предусмотрено действующим законодательством (налоговые, правоохранительные органы и др.) или соглашением субъекта персональных данных;</li>
                        <li>отказывать в предоставлении персональных данных в случаях предусмотренных действующим законодательством;</li>
                        <li>использовать персональные данные субъекта без его согласия, в случаях предусмотренных законодательством.</li>
                    </ul>
                    <p>Субъект персональных данных имеет право:</p>
                    <ul>
                        <li>требовать уточнения своих персональных данных, их блокирования или уничтожения в случае, если персональные данные являются неполными, устаревшими, недостоверными, незаконно полученными или не являются необходимыми для заявленной цели обработки, а также принимать предусмотренные законом меры по защите своих прав;</li>
                        <li>требовать перечень своих персональных данных, обрабатываемых Компанией и источник их получения;</li>
                        <li>получать информацию о сроках обработки своих персональных данных, в том числе о сроках их хранения;</li>
                        <li>требовать извещения всех лиц, которым ранее были сообщены неверные или неполные его персональные данные, обо всех произведенных в них исключениях, исправлениях или дополнениях;</li>
                        <li>обжаловать в уполномоченный орган по защите прав субъектов персональных данных или в судебном порядке неправомерные действия или бездействия при обработке его персональных данных.</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>5. Принципы и условия обработки персональных данных</h2>
                    <p>Обработка персональных данных в Компании производится на основе соблюдения принципов:</p>
                    <ul>
                        <li>законности целей и способов обработки персональных данных;</li>
                        <li>соответствия целей обработки персональных данных целям, заранее определенным и заявленным при сборе персональных данных;</li>
                        <li>соответствия объема и характера обрабатываемых персональных данных, способов обработки персональных данных целям обработки персональных данных;</li>
                        <li>достоверности персональных данных, их достаточности для целей обработки, недопустимости обработки персональных данных, избыточных по отношению к целям, заявленным при сборе персональных данных;</li>
                        <li>недопустимости объединения созданных для несовместимых между собой целей баз данных, содержащих персональные данные;</li>
                        <li>хранения персональных данных в форме, позволяющей определить субъекта персональных данных, не дольше, чем этого требуют цели их обработки;</li>
                        <li>уничтожения по достижении целей обработки персональных данных или в случае утраты необходимости в их достижении.</li>
                    </ul>
                    <p>
                        Отказ потребителя услуг Компании от предоставления согласия на обработку его персональных данных влечет за собой невозможность достижения целей обработки.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>6. Обеспечение безопасности персональных данных</h2>
                    <p>
                        Компания предпринимает необходимые организационные и технические меры для обеспечения безопасности персональных данных от случайного или несанкционированного доступа, уничтожения, изменения, блокирования доступа и других несанкционированных действий.
                    </p>
                    <p>
                        В целях координации действий по обеспечению безопасности персональных данных в Компании назначен ответственный за организацию защиты персональных данных.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>7. Заключительные положения</h2>
                    <p>
                        Настоящая Политика предназначена для размещения в информационных ресурсах общественного пользования Компании.
                    </p>
                    <p>
                        Настоящая Политика подлежит изменению, дополнению в случае появления новых законодательных актов и специальных нормативных документов по обработке и защите персональных данных, но не реже одного раза в три года.
                    </p>
                    <p>
                        Контроль исполнения требований настоящей Политики осуществляется ответственным за организацию обработки персональных данных Компании.
                    </p>
                    <p>
                        Ответственность должностных лиц Компании, имеющих доступ к персональным данным, за невыполнение требований норм, регулирующих обработку и защиту персональных данных, определяется в соответствии с законодательством Российской Федерации и внутренними документами Компании.
                    </p>
                </section>

                <section className="legal-section legal-documents">
                    <h2>Дополнительная информация</h2>
                    <ul className="legal-doc-list">
                        {documents.map((doc, i) => (
                            <li key={i}>
                                <a
                                    className="legal-doc-link"
                                    href={doc.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <FilePdfOutlined />
                                    {doc.name}
                                </a>
                            </li>
                        ))}
                    </ul>
                </section>
            </div>
        </div>
    );
};

export default LegalInfo;
